/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { DataRetentionTimeItem } from '../models/data-retention-time-item';
import { settingControllerGetDataRetentionPolicyTime } from '../fn/setting/setting-controller-get-data-retention-policy-time';
import { SettingControllerGetDataRetentionPolicyTime$Params } from '../fn/setting/setting-controller-get-data-retention-policy-time';
import { settingControllerUpdateDataRetentionPolicyTime } from '../fn/setting/setting-controller-update-data-retention-policy-time';
import { SettingControllerUpdateDataRetentionPolicyTime$Params } from '../fn/setting/setting-controller-update-data-retention-policy-time';

@Injectable({ providedIn: 'root' })
export class SettingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `settingControllerGetDataRetentionPolicyTime()` */
  static readonly SettingControllerGetDataRetentionPolicyTimePath = '/setting';

  /**
   * Ritorna il Data retention policy.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingControllerGetDataRetentionPolicyTime()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingControllerGetDataRetentionPolicyTime$Response(params?: SettingControllerGetDataRetentionPolicyTime$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DataRetentionTimeItem;
}>> {
    const obs = settingControllerGetDataRetentionPolicyTime(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ritorna il Data retention policy.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingControllerGetDataRetentionPolicyTime$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingControllerGetDataRetentionPolicyTime(params?: SettingControllerGetDataRetentionPolicyTime$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DataRetentionTimeItem;
}> {
    const resp = this.settingControllerGetDataRetentionPolicyTime$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DataRetentionTimeItem;
}>): BaseResponse & {
'data'?: DataRetentionTimeItem;
} => r.body)
    );
  }

  /** Path part for operation `settingControllerUpdateDataRetentionPolicyTime()` */
  static readonly SettingControllerUpdateDataRetentionPolicyTimePath = '/setting';

  /**
   * Modifica la Data retention policy.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingControllerUpdateDataRetentionPolicyTime()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settingControllerUpdateDataRetentionPolicyTime$Response(params: SettingControllerUpdateDataRetentionPolicyTime$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DataRetentionTimeItem;
}>> {
    const obs = settingControllerUpdateDataRetentionPolicyTime(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Modifica la Data retention policy.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingControllerUpdateDataRetentionPolicyTime$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settingControllerUpdateDataRetentionPolicyTime(params: SettingControllerUpdateDataRetentionPolicyTime$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DataRetentionTimeItem;
}> {
    const resp = this.settingControllerUpdateDataRetentionPolicyTime$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DataRetentionTimeItem;
}>): BaseResponse & {
'data'?: DataRetentionTimeItem;
} => r.body)
    );
  }

}
